import { render } from "./DatabaseTemplate.vue?vue&type=template&id=36ecb837&scoped=true"
import script from "./DatabaseTemplate.vue?vue&type=script&lang=js"
export * from "./DatabaseTemplate.vue?vue&type=script&lang=js"

import "./DatabaseTemplate.vue?vue&type=style&index=0&id=36ecb837&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ecb837"]])

export default __exports__